import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { SxProps, Theme } from '@mui/material/styles';
import { APP_VERSION, BUILD_NUMBER, getFormattedBuildDate } from '../../../utilities/version';

interface IVersionInfoProps {
  /** 'compact' shows only version, 'full' shows all details */
  variant?: 'compact' | 'full';
  sx?: SxProps<Theme>;
}

/**
 * Reusable version info display component.
 * - compact: single line with tooltip for details (used in Sidebar)
 * - full: multi-line with all info (used in Login)
 */
export default function VersionInfo({ variant = 'compact', sx }: IVersionInfoProps): React.ReactElement {
  const buildDate = getFormattedBuildDate();

  if (variant === 'full') {
    return (
      <Box sx={{ textAlign: 'center', ...sx }}>
        <Typography variant="caption" color="text.secondary" display="block">
          Version {APP_VERSION}
        </Typography>
        <Typography variant="caption" color="text.disabled" display="block">
          Build: {BUILD_NUMBER} | {buildDate}
        </Typography>
      </Box>
    );
  }

  // compact variant with tooltip
  return (
    <Tooltip
      title={
        <Box>
          <Typography variant="caption" display="block">Version: {APP_VERSION}</Typography>
          <Typography variant="caption" display="block">Build: {BUILD_NUMBER}</Typography>
          <Typography variant="caption" display="block">Updated: {buildDate}</Typography>
        </Box>
      }
      arrow
      placement="top"
    >
      <Box sx={{ textAlign: 'center', py: 1, cursor: 'default', ...sx }}>
        <Typography variant="caption" color="text.disabled" sx={{ fontSize: '0.7rem' }}>
          v{APP_VERSION} ({BUILD_NUMBER})
        </Typography>
      </Box>
    </Tooltip>
  );
}
